module.exports = __webpack_public_path__ + "img/pic_watch2@2x(1).6a78b34d.png";